export const defaultSettings = [
	'transformImage',
	'moveCoordinates',
	'resizeCoordinates',
	'defaultCoordinates',
	'defaultVisibleArea',
	'areaPositionRestrictions',
	'areaSizeRestrictions',
	'sizeRestrictions',
	'positionRestrictions',
	'aspectRatio',
	'minWidth',
	'minHeight',
	'maxWidth',
	'maxHeight',
	'defaultSize',
	'defaultPosition',
	'defaultTransforms',
	'imageRestriction',
	'priority',
];
